import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Router } from "@angular/router";
import { AuthenticationService } from './authentication.service';
import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: "root",
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router,
    private _authenticationService: AuthenticationService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (localStorage.getItem("token")) {
      req = req.clone({
        setHeaders: {
          ctoken: localStorage.getItem("token"),
        },
      });
    }
 /*   else {
      let infoUser = {
        userName: localStorage.getItem("nid")
      }
      this._authenticationService.logOut(infoUser).subscribe(
        data => {
          localStorage.clear();
          this.router.navigate(['login']);
        }
      );
    }*/

    return next.handle(req);

  }
}